import type * as d3 from 'd3'

import type { Dimensions } from 'modules/org_chart/models/Dimensions'
import type { VisibleBounds } from 'modules/org_chart/models/VisibleBounds'

export const computeVisibleBounds = (
  transform: d3.ZoomTransform,
  [width, height]: Dimensions,
  marginFactor: number
): VisibleBounds => {
  const marginX = width * marginFactor
  const marginY = height * marginFactor

  return {
    minX: (-transform.x - marginX) / transform.k,
    minY: (-transform.y - marginY) / transform.k,
    maxX: (-transform.x + width + marginX) / transform.k,
    maxY: (-transform.y + height + marginY) / transform.k,
  }
}

export const boundsContain = (outer: VisibleBounds, inner: VisibleBounds): boolean =>
  outer.minX <= inner.minX &&
  outer.minY <= inner.minY &&
  outer.maxX >= inner.maxX &&
  outer.maxY >= inner.maxY
